<ion-content #content (ionScroll)="onScroll($event)" scrollEvents="true">
  <div class="sb-sticky">
    <sports-live-navbar [breadcrumbs]="breadcrumbs" [light]="true" />
    <!-- SPORTS NAVBAR -->
    <sb-icon-bar
      [items]="sportsNav$ | async"
      [selectedItem]="selectedSportsNav"
      [isProcessing]="isProcessing"
      (selectItem)="setSelectedSportsNav($event, 0)"
    />

    <!-- COUNTRY / TOURNAMENT TABS -->
    <sb-tabs-categories
      [triggerScrollLeft]="selectedSportsNav?.SportHandle"
      [categories]="categories$ | async"
      [color]="'regular'"
      [scrollable]="true"
      [isMobile]="isMobile"
      [smallButton]="!isMobile"
      [selectedTab]="selectedCategory$ | async"
      (selectTab)="setCurrentFilter($event)"
    />
  </div>

  <ion-list class="sb-grid-content" *ngIf="(filteredLiveSport$ | async) as sport" no-padding no-margin>
    <ion-accordion-group
      [value]="'_aConstantValueToInitOpen'"
      *ngFor="let league of sport?.Leagues; trackBy: trackLeague;"
    >
      <ion-accordion [value]="'_aConstantValueToInitOpen'" lines="none">
        <ion-item slot="header" color="light" class="accordion--item ion-item-title" lines="none" mode="ios">
          <ion-label class="accordion--item-label">
            <p>{{ league?.LeagueName }}</p>
            <ion-avatar item-left class="accordion--item-label-flag">
              <img src="assets/global/img/banderas/ICO_{{ league?.CountryCode }}.png" />
            </ion-avatar>
          </ion-label>
          <ion-icon
            class="accordion--item-label-icon ion-accordion-toggle-icon"
            name="chevron-forward-outline"
            slot="start"
          />
        </ion-item>
        <div class="ion-accordion--content" slot="content">
          <ion-list class="accordion--list">
            <ion-item *ngFor="let event of league?.Events; let index = index">
              <sports-grid
                (navigate)="navigate('live-market', event)"
                [event]="event"
                mode="teams"
                [hasBets]="!!event?.DefaultGame?.Results?.length"
                [separator]="true"
              >
                <sports-grid-content-teams [event]="event" content (click)="navigate('live-market', event)" />
                <sb-overview-score-sets
                  *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.SETS"
                  [sportHandle]="event?.SportHandle"
                  [scoreboard]="event?.liveData"
                  scoreboard
                />
                <sb-overview-score-regular
                  *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.REGULAR"
                  [scoreboard]="event?.liveData"
                  scoreboard
                />

                <sports-group 
                  *ngFor="let game of event?.Games; let index = index"
                  (clicked)="navigate('live-market', event, game?.GameType)"
                  sb-markets
                >
                  <sports-bet-button
                    *ngFor="let result of game?.Results; let index = index"
                    [type]="game?.GameType"
                    [typeName]="game?.DisplayTypeName"
                    [game]="result"
                    [results]="game?.Results"
                    [index]="index"
                    (bet)="bet($event, event, game?.Name)"
                    [locked]="result?.Locked"
                    [home]="event?.teamHome"
                    [away]="event?.teamAway"
                    [sport]="event?.SportHandle"
                    [selected]="newTicketFacade?.hasResult(result.NodeId)"
                  />
                </sports-group>
                <sb-counter
                  *ngIf="!!event?.ChildrenCount && !isMobile"
                  [count]="event?.ChildrenCount"
                  (click)="navigate('live-market', event)"
                  counter-button
                />
              </sports-grid>
            </ion-item>
          </ion-list>
        </div>
      </ion-accordion>
    </ion-accordion-group>
  </ion-list>

  <codere-footer />
</ion-content>
